import React, { useState } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Paper,
  Box,
  Grid
} from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import TableChartIcon from "@material-ui/icons/TableChart";
import WarningIcon from "@material-ui/icons/Warning";
import SharedTitle from "./SharedForms/SharedTitle";
import { downloadCargaMasivaXls, getEspecificacionDotacion, subirCargaMasivaFt } from "services/api";
import { toast, CustomToast } from '@jumbo/components/custom/Toast';
import Spinner from "@jumbo/components/custom/Spinner";
import { useRef } from "react";

function getSteps() {
  return [
    "Descargar Archivos",
    "Cargar Dotación",
  ];
}

export default function StepperCarga() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [archivo, setArchivo] = React.useState(null);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [openResultado, setOpenResultado] = useState(false);
  const fileInputRef = useRef(null);

  const [resultadoCarga, setResultadoCarga] = useState({
    total_ok: 0,
    errores: []
  });

  const steps = getSteps();

  const handleNext = () => {
    setActiveStep(prev => prev + 1);
  };

  const handleBack = () => {
    setActiveStep(prev => prev - 1);
  };


  const descargarPlantilla = () => {
    downloadCargaMasivaXls()
      .then(res => {
        const blob = new Blob([res.data]);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "carga_masiva_personal_fichas_tecnicas.xlsx";
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch(() => toast.error("Error al descargar plantilla"));
  };

    const descargarEspecificacion = () => {
    getEspecificacionDotacion()
      .then(res => {
        const blob = new Blob([res.data]);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "ESPECIFICACIONES_CARGA_DOTACION.pdf";
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch(() => toast.error("Error al descargar plantilla"));
  };

  const handleUploadFile = e => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.name !== "carga_masiva_personal_fichas_tecnicas.xlsx") {
      toast.error('El archivo debe llamarse "carga_masiva_personal_fichas_tecnicas.xlsx".');
      return;
    }

    setArchivo(file)

  };

  const subirArchivo = () => {
    setLoadingUpload(true);

    let form = new FormData();
    form.append("file", archivo);

    subirCargaMasivaFt(form, sessionStorage.getItem("idFicha"))
      .then(res => {

        if (res.data.total_ok > 0 && res.data.errores.length === 0) {
          toast.success("Archivo cargado correctamente.");
        } else if (res.data.total_ok > 0 && res.data.errores.length > 0) {
          toast.warn("Archivo cargado con observaciones.");
        } else {
          toast.error("Archivo no cargado.\n "+res.data.error);
        }
        const r = res.data;

        const resultados = {
          total_ok: r?.total_ok ?? 0,
          errores: r?.errores ?? []
        };

        setResultadoCarga(resultados);
        setOpenResultado(true);

        //setReload(!reload);
      })
      .catch(() => toast.error("Error al cargar archivo"))
      .finally(() => {
        setLoadingUpload(false)
        setArchivo(null)
        if (fileInputRef.current) {
          fileInputRef.current.value = ""
        }
      });
  }

  const getStepContent = step => {
    switch (step) {
      case 0:
        return (
          <Box
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              height: "100%",
              minHeight: 373
            }}
          >
            <Typography variant="h3" style={{ fontWeight: 600, marginBottom: 10 }}>
              Paso 1:  Descargue especificación de datos de carga y plantilla
            </Typography>
            <Typography variant="h5" style={{ fontWeight: 400 }}>
              En esta sección se encuentran disponibles los documentos necesarios para completar el proceso: la
              especificación de datos, que detalla los campos y valores permitidos, y la plantilla que deberá ser
              utilizada para registrar la dotación de personal y posteriormente realizar su carga en el sistema.
            </Typography>
            <Grid container spacing={2} style={{ marginTop: 16 }} direction="column">
              <Grid item xs={12} md={4}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  startIcon={<PictureAsPdfIcon />}
                  style={{
                    justifyContent: "flex-start"
                  }}
                  onClick={()=>{descargarEspecificacion()}}
                >
                  ESPECIFICACIÓN DE DATOS DE CARGA (PDF)
                </Button>
              </Grid>

              <Grid item xs={12} md={4}>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<TableChartIcon />}
                  style={{
                    backgroundColor: "white",
                    color: "#2e7d32",
                    justifyContent: "flex-start",
                  }}
                  onClick={() => { descargarPlantilla() }}

                >
                  PLANTILLA DE CARGA (EXCEL)
                </Button>
              </Grid>
            </Grid>
            <Typography variant="h5" style={{ fontWeight: 400, marginBottom: 20, marginTop: 20 }}>
              Descargue ambos recursos para asegurar una carga exitosa.
            </Typography>
          </Box>
        );

      case 1:
        return (
          <>
            <Typography
              variant="h3"
              style={{ fontWeight: 600, marginBottom: 10 }}
            >
              Paso 3: Cargue su archivo y valide los resultados
            </Typography>

            <Paper
              variant="outlined"
              style={{
                padding: 10,
                border: "2px dashed #4a4a4a",
                borderRadius: 12,
                textAlign: "center",
                backgroundColor: "#fafafa",
                marginBottom: 24,
                height: 150
              }}
            >
              <CloudUploadIcon
                style={{
                  fontSize: 44,
                  color: "#1f2a60",
                  marginBottom: 5
                }}
              />

              <Typography
                variant="h6"
                style={{ marginBottom: 12 }}
              >
                Arrastre su Archivo Excel Aquí o
              </Typography>

              <input
                accept=".xls,.xlsx"
                style={{ display: "none" }}
                id="archivo-excel"
                type="file"
                ref={fileInputRef}
                onChange={handleUploadFile}
              />

              <label htmlFor="archivo-excel">
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                >
                  SELECCIONAR ARCHIVO
                </Button>
              </label>

              {archivo && (
                <Typography
                  style={{
                    marginTop: 12,
                    fontWeight: 500
                  }}
                >
                  Archivo seleccionado: {archivo.name}
                </Typography>
              )}
            </Paper>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                {
                  resultadoCarga.total_ok === 0 ?
                    null
                    :
                    <Paper
                      elevation={0}
                      style={{
                        padding: 20,
                        backgroundColor: "#eef8ee",
                        border: "1px solid #d6ead6",
                        borderRadius: 8,
                        minHeight: 160

                      }}
                    >
                      <Typography
                        variant="h6"
                        style={{ fontWeight: 700, marginBottom: 16 }}
                      >
                        Cargas de personal exitosas
                      </Typography>

                      <Box display="flex" alignItems="center" mb={1.5}>
                        <CheckCircleIcon
                          style={{
                            color: "#2e7d32",
                            marginRight: 8
                          }}
                        />
                        <Typography>{"Colaboradores cargados: " + resultadoCarga.total_ok}</Typography>
                      </Box>


                    </Paper>
                }
              </Grid>

              <Grid item xs={12} md={6}>
                {
                  resultadoCarga.errores.length ?
                    <Paper
                      elevation={0}
                      style={{
                        padding: 20,
                        backgroundColor: "#fff8e8",
                        border: "1px solid #f0dfb2",
                        borderRadius: 8,
                        minHeight: 160

                      }}
                    >
                      <Typography
                        variant="h6"
                        style={{ fontWeight: 700, marginBottom: 16 }}
                      >
                        Errores Detectados
                      </Typography>

                      {
                        resultadoCarga.errores.map((item, inedx) => {
                          return (
                            <Box display="flex" alignItems="center" mb={1.5} key={inedx}>
                              <WarningIcon
                                style={{
                                  color: "#d4a017",
                                  marginRight: 8
                                }}
                              />
                              <Typography>
                                {item.detalle + ' ' + item.rut + ' en fila: ' + item.fila}
                              </Typography>
                            </Box>
                          )
                        })
                      }

                    </Paper>
                    :
                    null
                }
              </Grid>
            </Grid>

          </>
        );

      default:
        return "Paso desconocido";

    }
  };

  return (
    <div style={{ width: "100%", flexBasis: "100%", backgroundColor: "white" }}>
      <CustomToast />
      {loadingUpload ?
        <Spinner show={loadingUpload} />
        :
        null
      }
      <SharedTitle title={"Carga masiva dotación de personal"} />

      <Grid item xs={12} style={{ padding: 25 }}>

        <p>
          En este módulo del sistema, se realizará la carga del personal de salud del
          prestador institucional, esta funcionalidad está conectada al Registro
          Nacional de Prestadores Individuales, por lo cual hay información que se
          cargará automáticamente. para poblar los datos. Para facilitar el llenado,
          usted podrá realizar una carga masiva de profesionales, en una Plantilla con
          formato y la Información con los códigos que se deben utilizar para las
          columnas de sexo, profesión, tipo de jornada, tipo de contrato, unidad
          funcional y objetor de conciencia.
        </p>

      </Grid>

      <Grid
        container
        direction="column"
        style={{
          flex: 1,
          paddingLeft: 24,
          paddingRight: 24,
          paddingBottom: 24
        }}
      >
        <Grid
          item
          style={{
            flex: 1,
            minHeight: 0
          }}
        >
          <Paper
            elevation={0}
            style={{
              paddingLeft: 24,
              paddingRight: 24,
              height: "100%",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>

            <Box
              mt={3}
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                minHeight: 0
              }}
            >
              {getStepContent(activeStep)}
            </Box>


            <Box mt={4} display="flex" justifyContent={activeStep !== 0 ? "space-between" : "flex-end"}>
              {activeStep !== 0 ?
                <Button
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  variant="contained"
                >
                  Anterior
                </Button>
                :
                null
              }

              {activeStep === 1 ?
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    subirArchivo()
                  }
                  }
                  disabled={archivo ? false : true}
                >
                  Cargar planilla
                </Button>
                :

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                  disabled={activeStep === steps.length - 1}
                >
                  Siguiente
                </Button>
              }
            </Box>

          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}